module.exports = "<svg viewBox=\"0 0 183.4 146.2\"><path fill=\"#1E1E1C\" d=\"M160.6 102.3v-33c0-2.2-1.8-4-4-4H99.7V43.9h18.9c2.2 0 4-1.8 4-4V4c0-2.2-1.8-4-4-4H64.8c-2.2 0-4 1.8-4 4v35.9c0 2.2 1.8 4 4 4h18.9v21.4H26.8c-2.2 0-4 1.8-4 4v33.1H4c-2.2 0-4 1.8-4 4v35.9c0 2.2 1.8 4 4 4h53.7c2.2 0 4-1.8 4-4v-35.9c0-2.2-1.8-4-4-4H38.9V81.3h105.7v21.1h-18.9c-2.2 0-4 1.8-4 4v35.9c0 2.2 1.8 4 4 4h53.7c2.2 0 4-1.8 4-4v-35.9c0-2.2-1.8-4-4-4h-18.8z\"></path></svg>"


//////////////////
// WEBPACK FOOTER
// ./svgs/offer-type.svg
// module id = 239
// module chunks = 1